import React, {useEffect, useState} from 'react';
import {getSubdomainSessionData} from '../utils/AppUtils';
import {useTheme} from '../../common/ProjectThemeProvider';
import {Keys, ModuleFieldsData, Modules} from '../config/AppConfig';
import {getJsonValue, setTabTitle} from '../../common/fusion-ui/utils/ReactUtils';
import {DefStrNA} from '../../common/fusion-ui/config/FusionConfig';
import {AppInterface} from "../index";
import {useConfig} from "../context/ConfigProvider";

const LegalNoticePage = React.memo(() => {
    const TAG = "LegalNoticePage";
    const theme = useTheme();
    const {updateConfig} = useConfig();

    const module = Modules.Legal;
    const mf = ModuleFieldsData[Modules.Company];

    const [legaData, setLegaData] = useState('');
    useEffect(() => {
        setTabTitle(module)
        updateConfig(Keys.config_ShowTabBar, false);
        updateConfig(Keys.config_showHomeRightPanels, false);
        updateConfig(Keys.tracker_currPageModule, module);
        updateConfig(Keys.tracker_currPageTag, TAG);
        setLegaData(getJsonValue(getSubdomainSessionData(), mf.legalNotice.column, DefStrNA));
    }, []);

    return (<>
            <AppInterface label={module} showHome={true}>
                <div className={`text-wrap`} style={{color: theme.text}}
                     dangerouslySetInnerHTML={{__html: legaData}}
                />
            </AppInterface>
        </>
    );
})
export default LegalNoticePage;
